export default "__VITE_ASSET__DCVMlbm1__"